import React from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Typography,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogActions,
  IconButton,
} from '@material-ui/core';
import {ErrorOutline as ErrorOutlineIcon} from '@material-ui/icons';
import {I18nContext} from 'contexts/i18n';

export default class DeletionConfirm extends React.Component {
  static propTypes = {
    componentClass: PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.symbol]),
    componentProps: PropTypes.object.isRequired,
    itemName: PropTypes.string,
    alertText: PropTypes.string,
    DeleteButton: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
    renderDeleteButton: PropTypes.func,
    DeleteButtonProps: PropTypes.object.isRequired,
    deleteAction: PropTypes.func.isRequired,
  };
  static defaultProps = {
    componentClass: React.Fragment,
    componentProps: {},
    DeleteButton: 'span',
    DeleteButtonProps: {},
  };

  constructor(props) {
    super(props);
    this.state = {
      modalOpen: false,
    };
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.handleModalConfirm = this.handleModalConfirm.bind(this);
  }

  openModal() {
    this.setState({
      modalOpen: true,
    });
  }

  closeModal() {
    this.setState({
      modalOpen: false,
    });
  }

  handleModalConfirm() {
    const {deleteAction} = this.props;
    deleteAction();
    this.closeModal();
  }

  render() {
    const {modalOpen} = this.state;
    const {
      componentClass: RootComponent,
      componentProps,
      itemName,
      alertText,
      DeleteButton,
      renderDeleteButton,
      DeleteButtonProps,
    } = this.props;
    const text = alertText ? alertText : `Please confirm that you wish to delete this ${itemName || 'item'}`;
    return (
      <I18nContext.Consumer>
        {({i18nTranslate}) => (
          <RootComponent {...componentProps}>
            {modalOpen && (
              <Dialog open onClose={this.closeModal} maxWidth="xs" fullWidth>
                <DialogContent>
                  <Typography align="center" color="error" gutterBottom className="rtl-exempted">
                    <ErrorOutlineIcon style={{width: '6rem', height: '6rem'}} />
                  </Typography>
                  <Typography variant="h5" align="center" color="error" gutterBottom className="rtl-exempted">
                    {i18nTranslate`Are you sure?`}
                  </Typography>
                  <DialogContentText align="center">{i18nTranslate([text])}</DialogContentText>
                </DialogContent>
                <DialogActions>
                  <Button onClick={this.closeModal}>{i18nTranslate`Cancel`}</Button>
                  <Button variant="contained" color="primary" onClick={this.handleModalConfirm}>
                    {i18nTranslate`Delete`}
                  </Button>
                </DialogActions>
              </Dialog>
            )}
            {renderDeleteButton ? (
              renderDeleteButton({openModal: this.openModal})
            ) : (
              <DeleteButton onClick={this.openModal} {...DeleteButtonProps} />
            )}
          </RootComponent>
        )}
      </I18nContext.Consumer>
    );
  }
}

export const DeleteButton = ({alertText, onDeleteAction, DeleteIcon}) => (
  <DeletionConfirm
    alertText={alertText}
    deleteAction={onDeleteAction}
    renderDeleteButton={({openModal}) => (
      <IconButton onClick={openModal}>
        <DeleteIcon />
      </IconButton>
    )}
  />
);

DeleteButton.propTypes = {
  alertText: PropTypes.string,
  onDeleteAction: PropTypes.func.isRequired,
  DeleteIcon: PropTypes.any.isRequired,
};
